import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import BoxEmployee from '../BoxEmployee';
import Icon from '../Icon';

const StyleBoxEmployee = styled(BoxEmployee)`
  ${props =>
    props.more &&
    css`
      padding-bottom: ${rem('15px')};
    `};
  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.more &&
      css`
        padding-bottom: ${rem('30px')};
      `};
  `};
`;

const StyleList = styled.ul`
  margin: 0;
  padding-left: 0;
`;

const StyleItem = styled.li`
  font-size: ${props => props.theme.fontSize.small};
  padding-left: 1rem;
  text-transform: capitalize;
  :before {
    background-color: ${props => props.theme.colors.dark};
  }
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.medium};
  `};
`;

const StyleInterestItem = StyleItem.extend`
  display: inline-block;
  margin-right: ${rem('20px')};
`;

const StyleVolunteerItem = StyleItem.extend`
  line-height: ${rem('18px')};
  padding-bottom: ${rem('8px')};
  text-transform: none;
  :before {
    top: 0.425rem;
  }
`;

const StyleOptions = styled.span`
  font-family: ${props => props.theme.fonts.medium};
  font-size: inherit;
  text-transform: lowercase;
  display: inline-block;
  &:first-letter {
    text-transform: uppercase;
  }
  > span {
    text-transform: none;
    display: initial;
  }
`;

const StyleLanguageCertificate = styled.span`
  font-family: inherit;
  font-size: inherit;
`;

const StyleEditIcon = styled(Icon)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export {
  StyleList,
  StyleItem,
  StyleOptions,
  StyleLanguageCertificate,
  StyleInterestItem,
  StyleVolunteerItem,
  StyleBoxEmployee,
  StyleEditIcon
};
